import { useState } from 'react';
import { useAuth } from './useAuth';
import { setProjeDetayHandler, getProjeDetayHandler } from '../utility/projeDetayHandler';
import { getAcilanCalismaBilgi } from '../utility/acilanCalismaBilgi';

import { UYGULAMA_YONETICISI, FIRMA } from '../constants/roleConstant';
import YerbisConstants from '../constants/yerbisConstants';

export const useProjeDetay = () => {
  const { hasRole } = useAuth();
  const [getProjeDetayState, setProjeDetayState] = useState(null);

  const setProjeDetay = (detay) => {
    setProjeDetayHandler(detay);
  };

  const getProjeDetay = () => {
    const detay = getProjeDetayHandler();
    setProjeDetayState(detay);
    return detay;
  };

  const getProjeDurumId = () => {
    const detay = getProjeDetayHandler();
    return detay?.model?.proje?.durum_id ?? null;
  };

  const getProjeKilit = () => {
    const detay = getProjeDetayHandler();
    return detay?.model?.proje?.kilitli_mi ?? null;
  };

  const getProjeKamu = () => {
    const detay = getProjeDetayHandler();
    return detay?.model?.proje?.isKamu ?? 0;
  };

  const getAcilanCalismaDurumu = () => {
    const calismaBilgi = getAcilanCalismaBilgi();
    return calismaBilgi ?? null;
  };

  const getAraziBuroKontrol = (byPassDurum = false) => {
    const durum = getAcilanCalismaDurumu();
    if (!byPassDurum && durum != null && durum == YerbisConstants.ProjeEtudDurumlari.Kabul) {
      return true;
    }
    const kilitMi = getProjeKilit();
    if (kilitMi == YerbisConstants.kilitDurumId.kilitli) {
      return true;
    }

    const durumId = getProjeDurumId();
    if (durumId == YerbisConstants.ProjeDurumKodlari.Arsiv) {
      return true;
    }
    if (hasRole(UYGULAMA_YONETICISI) || durumId == YerbisConstants.ProjeDurumKodlari.AraziVeBuroCalismalari) {
      return false;
    }
    return true;
  };

  const getRasterKontrol = () => {
    const kilitMi = getProjeKilit();
    if (kilitMi == YerbisConstants.kilitDurumId.kilitli) {
      return true;
    }
    const durumId = getProjeDurumId();
    const isKamu = getProjeKamu();
    if (durumId == YerbisConstants.ProjeDurumKodlari.Arsiv) {
      return true;
    }
    if (
      hasRole(UYGULAMA_YONETICISI) ||
      durumId == YerbisConstants.ProjeDurumKodlari.AraziVeBuroCalismalari ||
      durumId == YerbisConstants.ProjeDurumKodlari.Hazirlik
    ) {
      return false;
    }
    if (hasRole(FIRMA) && durumId == YerbisConstants.ProjeDurumKodlari.OnEtut && isKamu == 1) {
      return false;
    }
    return true;
  };

  const getArsivKontrol = () => {
    const kilitMi = getProjeKilit();
    if (kilitMi == YerbisConstants.kilitDurumId.kilitli) {
      return true;
    }
    const durumId = getProjeDurumId();
    if (durumId == YerbisConstants.ProjeDurumKodlari.Arsiv) {
      return true;
    }
    return false;
  };

  const getAltYukleniciKontrol = () => {
    const kilitMi = getProjeKilit();
    if (kilitMi == YerbisConstants.kilitDurumId.kilitli) {
      return true;
    }
    const durumId = getProjeDurumId();
    if (durumId == YerbisConstants.ProjeDurumKodlari.Arsiv) {
      return true;
    }
    if (
      hasRole(UYGULAMA_YONETICISI) ||
      durumId == YerbisConstants.ProjeDurumKodlari.Hazirlik ||
      durumId == YerbisConstants.ProjeDurumKodlari.AraziVeBuroCalismalari ||
      durumId == YerbisConstants.ProjeDurumKodlari.OnEtut
    ) {
      return false;
    }
    return true;
  };

  return {
    getProjeDetay,
    setProjeDetay,
    getProjeDurumId,
    getAraziBuroKontrol,
    getRasterKontrol,
    getArsivKontrol,
    getAltYukleniciKontrol,
    getProjeKilit,
  };
};
